import { useCallback, useRef } from "react";
import { EmoteVis } from "@/animations/Emote";
import { randomIntFromInterval } from "@/canv/utils";

export const useReaction = () => {
    const reactionRef = useRef<EmoteVis[]>([]);

    const setReactionRef = useCallback((x, y, reactionSrc, canvas) => {
        const count = randomIntFromInterval(1, 3);

        for (let i = 0; i < count; i++) {
            const emote = new EmoteVis(x, y, reactionSrc, canvas);

            reactionRef.current.push(emote);
        }
    }, []);

    const reactionDraw = useCallback(() => {
        for (let i = 0; i < reactionRef.current.length; i++) {
            reactionRef.current[i].draw();
        }
    }, []);

    const reactionStep = useCallback(() => {
        for (let i = 0; i < reactionRef.current.length; i++) {
            if (reactionRef.current[i].finished) {
                reactionRef.current.splice(i, 1);
                i--;
                continue;
            }
            reactionRef.current[i].step();
        }
    }, []);

    const reactionStart = useCallback(() => {
        reactionDraw();
        reactionStep();
    }, [reactionDraw, reactionStep]);

    return {
        reactionRef,
        setReactionRef,
        reactionStart,
    };
};
